import { createFileRoute, useParams } from '@tanstack/react-router'
import { DrawingDetailPage } from '@/src/components/manage/views/DrawingDetailPage'

type DrawingTab = 'data' | 'operations' | 'json' | 'viewer'

const isValidTab = (tab: unknown): tab is DrawingTab => {
  return tab === 'data' || tab === 'operations' || tab === 'json' || tab === 'viewer'
}

export const Route = createFileRoute('/_manage/manage/drawings/$id')({
  component: DrawingsEditPage,
  validateSearch: (search: Record<string, unknown>) => {
    const tab = search.tab
    return { tab: isValidTab(tab) ? tab : 'data' }
  },
})

function DrawingsEditPage() {
  const { id } = useParams({ from: '/_manage/manage/drawings/$id' })
  const navigate = Route.useNavigate()
  const { tab } = Route.useSearch()

  return (
    <DrawingDetailPage
      id={id}
      backTo="/manage/drawings"
      activeTab={tab}
      onTabChange={(nextTab) => navigate({ search: { tab: nextTab } })}
    />
  )
}
